var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { cloneElement } from 'react';
import { useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core';
export const UserProfileTitle = (_a) => {
    var { actions, basePath, resource, record } = _a, rest = __rest(_a, ["actions", "basePath", "resource", "record"]);
    const translate = useTranslate();
    const classes = useStyles(rest);
    return (React.createElement("div", { className: classes.root },
        translate('resources.userContexts.title'),
        actions &&
            cloneElement(actions, {
                basePath,
                resource,
                record,
            })));
};
const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
}), {
    name: 'Layer7UserContextTitle',
});
//# sourceMappingURL=UserProfileTitle.js.map